<template>
    <div class="reset-content">
        <div class="reset-modal">
            <img src="@/assets/logo.png" width="200" alt="Logo" />
            <hr>
            <div class="reset-title">Redefinir senha</div>
            <input v-model="user.password" id="password" name="password" ref="password" type="password" placeholder="Nova senha">
            <input v-model="user.passwordconfirm" id="passwordconfirm" name="passwordconfirm" ref="passwordconfirm" type="password" placeholder="Confirmar Senha">
            <b-button id="btn-principal" @click="resetpassword" variant="success" style="width: 120px;">Enviar</b-button>
        </div>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'

export default {
    name: 'Reset',
    data() {
        return {
            user: {}
        }
    },
    methods: {
        resetpassword() {
            // Senha e Confirmacao são obrigatorios
            var password = document.getElementById('password').value
            if (password == "") {
                this.$toasted.global.defaultError({ msg: 'Favor informar a senha!'})
                document.getElementById('password').focus()
                return
            }
            var passwordconfirm = document.getElementById('passwordconfirm').value
            if (passwordconfirm == "") {
                this.$toasted.global.defaultError({ msg: 'Favor informar a confirmação de senha!'})
                document.getElementById('passwordconfirm').focus()
                return
            }
            if (password !== passwordconfirm) {
                this.$toasted.global.defaultError({ msg: 'As senhas não são correspondentes!'})
                document.getElementById('password').focus()
                return
            }

            // Se tudo ok atualiza senha
			var url = new URL(window.location.href);
			var id = url.searchParams.get("id");
			var token = url.searchParams.get("token");
            axios.post(`${baseApiUrl}/redefinirsenha/id/${id}/token/${token}`, this.user) 
                 .then(resp => {
                     // Status = OK - Email registrado!
                     if (resp.data.status) {
                         this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                         this.reset = {}
                         setTimeout(function() {}, 2000)

                         // Após atualizar senha navega para tela de login
                         this.$router.push({ path: '/auth' })
                     } else 
                     {
                        // Status = OK - Email NÃO registrado!
                        this.$toasted.global.defaultError({ msg: resp.data.mensagem })
                        setTimeout(function() {}, 2000)

                        // Após atualizar senha navega para tela de login
                        this.$router.push({ path: '/auth' })
                     }
                 })
                 .catch(showError)   
        }
	}
}
</script>

<style>
    .reset-content {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .reset-modal {
        background-color: #fff;
        width: 400px;
        padding: 25px;
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 0.25rem;        
    }    

    .reset-title {
        font-size: 1.2rem;
        font-weight: 100;
        margin-bottom: 15px;
    }

    .reset-sub-title {
        font-size: 1rem;
        margin-bottom: 25px;
        color: #666666;
    }
    

    .reset-modal input {
        margin-bottom: 15px;
    }

    .reset-modal button {
        align-self: center;
        margin-top: 10px;
        padding: 5px 15px;
        cursor: pointer;
    }

    .reset-modal a {
        margin-top: 15px;
        color: #666666;        
    }

    .reset-modal hr {
        border: 0;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }

    #btn-principal {
		color: #fff;
		background-color: #009587;
		border-color: #009587;
	}	
</style>